import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/Core';
  }

  enviarCarga(idCarga: number){
    return this.httpClient.put(this.endpoint + '/EnviarCarga/' + idCarga, {});
  }

  reenvioCarga(load: any){
    return this.httpClient.put(this.endpoint + `/EnviarCarga/${load.idCarga}`,load);
  }

}
